var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraytw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.76471C14.4479 2.07353 13.8528 2.27647 13.2361 2.37353C13.8671 1.90588 14.3547 1.16471 14.5841 0.273529C13.989 0.714706 13.3294 1.02353 12.6338 1.2C12.0674 0.441177 11.2715 0 10.3681 0C8.68308 0 7.30641 1.69412 7.30641 3.78529C7.30641 4.08529 7.33509 4.37647 7.38528 4.65C4.8327 4.49118 2.55975 2.98235 1.04685 0.697059C0.781549 1.25294 0.630975 1.90588 0.630975 2.59412C0.630975 3.90882 1.16874 5.07353 2.00048 5.73529C1.4914 5.73529 1.01816 5.55882 0.602295 5.29412V5.32059C0.602295 7.15588 1.66348 8.69118 3.06883 9.03529C2.61763 9.18724 2.14395 9.20838 1.68499 9.09706C1.87974 9.84925 2.26114 10.5074 2.77559 10.9791C3.29003 11.4507 3.91165 11.7121 4.55306 11.7265C3.4658 12.7857 2.11807 13.3582 0.731358 13.35C0.487572 13.35 0.243786 13.3324 0 13.2971C1.36233 14.3735 2.98279 15 4.71797 15C10.3681 15 13.4728 9.22941 13.4728 4.22647C13.4728 4.05882 13.4728 3.9 13.4656 3.73235C14.0679 3.20294 14.5841 2.53235 15 1.76471Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraytw);
export default __webpack_public_path__ + "static/media/graytw.85c59a452dfff1623c3fd1f9be9ceca6.svg";
export { ForwardRef as ReactComponent };